query AssistantConversationsList(
  $page: Int
  $rowsPerPage: Int
  $filter: AssistantConversationsFilterInput
) {
  assistantConversations(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      audience
      title
      topic
      messageCount
      lastMessageAt
      createdAt
      hasRequest
      knowledgeGap
      likes
      dislikes
      costUsd
      origin
      user {
        id
        email
        displayName
      }
      platform {
        id
        title
      }
      organization {
        id
        title
      }
    }
  }
}
